import React, { useEffect, useRef } from 'react';

import ModalLarge from '../../../general-components/modal-large';
import MultiButtonConfirmationModal from '../multi-button-confirmation-modal';

export interface RtmpValidationOverrideProps {
	resolveValidation: () => void;
	closeModal: () => void;
	closeIfClickOutside?: boolean;
}

export default function RtmpValidationOverride({
	resolveValidation,
	closeModal,
	closeIfClickOutside = false,
}: RtmpValidationOverrideProps) {
	const clickableRef = useRef<HTMLDivElement>(null);

	// Focus on mount to allow user click outside to close
	useEffect(() => {
		clickableRef.current?.focus();
	}, []);

	const handleBlur = (event?: React.FocusEvent<HTMLElement>) => {
		if (!closeIfClickOutside || !event) {
			return;
		}

		if (!event.currentTarget?.contains(event.relatedTarget as Node)) {
			closeModal();
		}
	};

	return (
		<ModalLarge
			open={true}
			close={() => {}}
			className="rtmp-validation-override"
			closeIfClickOutside={true}
		>
			<div
				className="rtmp-validation-override-clickable"
				onBlur={handleBlur}
				tabIndex={0}
				ref={clickableRef}
			>
				<MultiButtonConfirmationModal
					headerText="This destination is invalid"
					firstButtonText="Save anyway"
					firstButtonAction={resolveValidation}
					secondButtonText="Close"
					secondButtonAction={closeModal}
					isOpen
					buttonAlignment="right"
				>
					<div className="bl-font-p2 grayscale-200">
						The destination you're attempting to save is not active. If you
						believe this destination will eventually become active, you can
						still save it.
					</div>
				</MultiButtonConfirmationModal>
			</div>
		</ModalLarge>
	);
}
